// MUI
import { Typography } from '@mui/material';

export interface ContentTitleProps {
    children: React.ReactNode;
}

export default function ContentTitle(props: ContentTitleProps) {
    return <Typography {...props} variant='h3' />;
}
